import { withVisibility, WithVisibilityProps } from '../HOC/withVisibility';
import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';
import * as ChatBubbleIcon from 'react-icons/lib/io/chatbubble';
import colors from '../colors';

interface Props extends WithVisibilityProps {
    className?: string;
    numUnread: number;
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
}
interface State {}

class Minimized extends React.Component<Props, State> {
    private originalPageTitle: string;
    private titleInterval: any;

    componentDidMount() {
        this.originalPageTitle = window.document.title;
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.numUnread > prevProps.numUnread) {
            if (typeof Audio !== 'undefined') {
                const audio = new Audio(
                    'https://s3.amazonaws.com/conversations-files/global/sounds/Peak_Note1.mp3',
                );
                audio.play();
            }
            this.blinkTitleTag();
        }

        // once this tab becomes visible, reset page title and mark all read
        if (prevProps.isVisible === false && this.props.isVisible === true) {
            clearInterval(this.titleInterval);
            window.document.title = this.originalPageTitle;
        }
    }

    blinkTitleTag() {
        if (!this.props.isVisible) {
            clearInterval(this.titleInterval);

            let tag = `${this.props.numUnread} New Message`;
            if (this.props.numUnread > 1) tag += 's';
            const title = `${tag} - ${this.originalPageTitle}`;
            window.document.title = title;
            this.titleInterval = setInterval(() => {
                window.document.title =
                    window.document.title === title ? this.originalPageTitle : title;
            }, 1000);
        }
    }

    render() {
        return (
            <Positioner className={this.props.className}>
                {this.props.numUnread > 0 && <Unread>{this.props.numUnread}</Unread>}
                <ActiveConvoIndicator show={this.props.numUnread === 0}>
                    <Circle className="conversations-cta" href="#" onClick={this.props.onClick}>
                        <ChatBubbleIcon size={50} />
                    </Circle>
                </ActiveConvoIndicator>
            </Positioner>
        );
    }
}

export default withVisibility(Minimized);

export const Positioner = styled.div`
    position: fixed;
    bottom: 20px;
    right: 20px;
    left: auto;
    transition: transform 0.15s ease-in;
    &:hover {
        color: ${colors.white};
        transform: scale(1.05);
    }
`;

export const Circle = styled.a`
    background-color: ${props => props.theme.accentColor2};
    color: ${colors.white};
    &:hover {
        color: ${colors.white};
    }
    border: 2px solid ${colors.white};
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const div: StyledFunction<{ show: boolean } & React.HTMLProps<HTMLInputElement>> = styled.div;
const ActiveConvoIndicator = div`
    background-color: ${props => (props.show ? props.theme.accentColor1 : 'transparent')};
    border-radius: 50%;
    padding: 3px;
`;

const Unread = styled.div`
    position: absolute;
    top: -5px;
    left: -5px;
    background-color: ${colors.red};
    color: ${colors.white};
    width: 20px;
    height: 20px;
    border-radius: 50% 50% 0 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 500;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Minimized.tsx